var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Pagination as PaginationCustom } from 'semantic-ui-react';
import Icon from '../../components/icon';
import { Styled } from './style';
var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentPage: props.defaultActivePage ? +props.defaultActivePage : 1,
        };
        return _this;
    }
    Pagination.prototype.render = function () {
        var _this = this;
        var prevItem = { content: React.createElement(Icon, { name: "arrow-left" }), icon: true };
        if (this.state.currentPage === 1) {
            prevItem = null;
        }
        var nextItem = { content: React.createElement(Icon, { name: "arrow-right" }), icon: true };
        if (this.state.currentPage === this.props.totalPages) {
            nextItem = null;
        }
        var ellipsisItem = { content: React.createElement(Icon, { name: "dot" }), icon: true };
        return (React.createElement(Styled, null,
            React.createElement(PaginationCustom, __assign({}, this.props, { boundaryRange: 1, ellipsisItem: ellipsisItem, firstItem: null, lastItem: null, siblingRange: 1, prevItem: prevItem, nextItem: nextItem, pointing: true, onPageChange: function (e, page) {
                    _this.setState({
                        currentPage: page.activePage,
                    });
                    if (_this.props.onPageChange) {
                        _this.props.onPageChange(e, page);
                    }
                } }))));
    };
    Pagination.propTypes = {
        defaultActivePage: PropTypes.number,
        totalPage: PropTypes.number,
        onPageChange: PropTypes.func,
    };
    return Pagination;
}(React.Component));
export default Pagination;
//# sourceMappingURL=index.js.map